// Arquivo: ModalCriarStyle.js
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const slideIn = keyframes`from { transform: translateY(-30px); opacity: 0; } to { transform: translateY(0); opacity: 1; }`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: ${fadeIn} 0.3s ease;
  padding: 20px;
  box-sizing: border-box;
`;

export const ModalContainer = styled.div`
  background: #282828;
  border-radius: 12px; // Bordas mais suaves
  width: 100%;
  max-width: 900px; // Aumentado para acomodar as colunas
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  animation: ${slideIn} 0.4s ease-out;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ModalHeader = styled.div`
  padding: 20px 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    margin: 0;
    color: #e6aa3a;
    font-size: 22px;
    font-weight: 600;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #fff;
  font-size: 28px;
  cursor: pointer;
  opacity: 0.7;
  transition: all 0.3s;
  line-height: 1;
  &:hover {
    opacity: 1;
    transform: rotate(90deg);
  }
`;

export const ModalBody = styled.div`
  padding: 30px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #444;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 25px; // Aumenta o espaçamento
  margin-bottom: 30px;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative; /* Para a mensagem de erro */

  label {
    color: #ccc; // Cor mais suave
    font-weight: 500;
    font-size: 14px;
  }
  input {
    height: 45px;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: #fff;
    padding: 0 15px;
    border-radius: 6px;
    font-size: 16px;
    transition: border-color 0.3s, box-shadow 0.3s;
    &:focus {
      outline: none;
      border-color: #e6aa3a;
      box-shadow: 0 0 0 3px rgba(230, 170, 58, 0.2);
    }
  }
`;

export const ErrorMessage = styled.p`
  color: #ff4d4d;
  font-size: 12px;
  margin: 5px 0 0;
  position: absolute;
  bottom: -20px;
`;

export const PermissionsSectionTitle = styled.h4`
  color: #e6aa3a;
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 10px;
`;

export const PermissionsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

export const PermissionsBox = styled.div`
  background-color: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 20px;

  h5 {
    margin: 0 0 15px 0;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
  }
`;

export const PermissionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PermissionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: background-color 0.2s;
  user-select: none;

  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }

  span {
    color: #ddd;
    font-size: 14px;
  }
`;

export const Checkbox = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  background-color: ${(props) => (props.checked ? "#e6aa3a" : "transparent")};
  transition: all 0.2s;
  position: relative;

  ${(props) =>
    props.checked &&
    `
    border-color: #e6aa3a;
    &::after {
      content: '✔';
      color: #111;
      font-size: 12px;
      font-weight: bold;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  `}
`;

export const ModalFooter = styled.div`
  padding: 20px 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  background-color: rgba(0, 0, 0, 0.2);
`;

const BaseButton = styled.button`
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const CancelButton = styled(BaseButton)`
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const SaveButton = styled(BaseButton)`
  background: #e6aa3a;
  color: #111;
  &:hover:not(:disabled) {
    background: #ffc300;
  }
`;
